import axios from 'axios';

const { REACT_APP_API_GATEWAY_URL } = process.env;

export const getFeatureFlagsAPI = async () => axios
  .get(`${REACT_APP_API_GATEWAY_URL}/feature_flags`, {
    headers: { scope: '' },
  }).catch((err) => ({ error: err }));
export default getFeatureFlagsAPI;
